import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { FilterContext } from "../FilterContext";
import { initialUserToClientLifecycleOption, UserToClientLifecycleFilterType, UserToClientLifecycleOption, UserToClientLifecycleOptions } from "./FilterTypes/UserToClientLifecycleFilterType";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const UserToClientLifecycleFilter = () => {
  const title = RESX.SoUser.Access;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): UserToClientLifecycleFilterType => initialUserToClientLifecycleOption;
  register("userToClientLifecycle", {
    getTitle: () => title,
    renderSelection: (value) => <>{value.options.map(o => o.label).join(", ")}</>,
    hasValue: (value) => value.options.length > 0,
    reset,
    areEqual: (a, b) => areArrayValuesEqual(a.options.map(o => o.value), b.options.map(o => o.value))
  });
  useEffect(() => {
    setInitialValue("userToClientLifecycle", reset());
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = React.useState(initialUserToClientLifecycleOption.options);

  const onChange = (option: UserToClientLifecycleOption) => {
    setSelectedOptions([option]);
    onPopupClose();
  };

  const onPopupClose = () => {
    setValue("userToClientLifecycle", { options: selectedOptions });
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedOptions(getValue("userToClientLifecycle").options);
    setPopupOpen(true);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<div>
        <SelectableList
          noSearch
          items={UserToClientLifecycleOptions}
          selectedItems={selectedOptions}
          onItemToggled={onChange}
          getId={opt => opt.value}
          getName={opt => opt.label}
        />
      </div>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default UserToClientLifecycleFilter;